module.exports = __webpack_public_path__ + "assets/images/4gm.jpg";